export const parseOffetTime = (offsetTime?: string): number | null => {
  if (!offsetTime) return null;
  return Date.parse(`${new Date(Date.now()).toDateString()} ${offsetTime}`);
};
